import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "@/lib/analytics";

function trackRoute(location) {
  initAnalytics();
  trackPageView(location);
}

export default function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackRoute(location);
  }, [location]);

  return null;
}
